module.exports = __webpack_public_path__ + "img/ep-rond.b9ccec15.jpg";